var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"formulate-input-label formulate-input-label--after",attrs:{"for":"context.id"},domProps:{"innerHTML":_vm._s(_vm.context.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }